import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Grid, TextField } from '@mui/material';
import { Add, People } from '@mui/icons-material';
import { GlobalBox } from '../../components/Box/GlobalBox';
import CardTable from '../../components/CardTable/CardTable';
import RegularButton from '../../components/CustomButtons/Button';
import { ModalV2 } from '../../components/Modal/ModalV2';
import { columns } from './columns';
import { FormEmployeeEdit } from './FormEmployeesEdit';
import { useOpenComponent } from '../../hooks/useOpenComponent';
import { useSearch } from '../../hooks/useSearch';
import { useValidateReload } from '../../hooks/useValidateReload';
import { 
  resetEmployeeSelected,
  addEmployeeMode,
  getEmployees,
  getEmployeesData,
} from '../../redux/actions/employeesCatalog/employeesCatalogActions';

const base = "loadingEmployees";
const loadings = [
  `${base}`,
  `${base}Crud`,
];

export const EmployeesCatalog = () => {
  const { 
    changeStation, 
    setSnackbar, 
  } = useSearch();

  const { rules } = useSelector(state => state.login);
  const { employeesArr } = useSelector(state => state.employeesCatalog);
  const { stationsSelected, isLoadingComp } = useSelector((state) => state.search);
  const { stationsList } = useSelector(state => state.companies);
  const { isOpen, handleIsOpen } = useOpenComponent();
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  useValidateReload(loadings);
  const fetchEmployees = useCallback(
    ( stationID ) => {
      dispatch(getEmployees( stationID ));
    },
    [dispatch]
  );

  const handleChangeStations = (e, item) => {
    if(item) changeStation(item);
    else changeStation([]);
  };
  
  const handleSubmit = useCallback(() => {
    if (stationsSelected.length < 1) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    const stationID = stationsSelected.id;
    fetchEmployees( stationID );
    setSubmitted(true);
  }, [ stationsSelected, setSnackbar, fetchEmployees]);

  const handleClose = () => {
    dispatch(resetEmployeeSelected());
    handleIsOpen();
  };
  
  const handleOpenAdd = () => {
    dispatch(resetEmployeeSelected());
    dispatch(addEmployeeMode());
    handleIsOpen();
  };

  // Effects
  useEffect(() => {
    dispatch(getEmployeesData());
  }, []);


  useEffect(() => {
    const isEmpty = employeesArr.length === 0;
    if (isEmpty && submitted) {
      setSnackbar("No se encontraron empleados");
    }
    setSubmitted(false);
    // eslint-disable-next-line
  }, [employeesArr]);


  return (
    <React.Fragment>
      <GlobalBox
        icon={<People />}
        title="Catalogo de Empleados"
        controls={
          rules.includes('PREPAYROLL-ADMIN') && 
            <RegularButton round justIcon color="info" style={{ margin: 10 }} onClick={handleOpenAdd}>
              <Add style={{ margin: 0 }}/>
            </RegularButton>
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>    
            <Autocomplete
              filterSelectedOptions
              options={stationsList}
              getOptionLabel={(station) => station.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="station"
                  value={stationsSelected?.id}
                  label="Buscar por plantas"
                  variant="outlined"
                />
              )}
              fullWidth
              onChange={(e, v) => handleChangeStations(e, v)}
              noOptionsText={"No hay resultados"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
            <RegularButton onClick={handleSubmit} color='info' style={{height: '100%', margin: 0}} fullWidth>Buscar</RegularButton>
          </Grid>
        </Grid>
        <CardTable
          data={employeesArr}
          columns={columns}
          isLoading={isLoadingComp?.loadingEmployees}
          blockBtn
        />
      </GlobalBox>

      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        isLoading={isLoadingComp?.loadingEmployeesCrud}
      >
        <FormEmployeeEdit handleClose={handleClose}/>
      </ModalV2>
    </React.Fragment>
  );
};
